import { ProductListItem } from "inventory/list/InventoryListReducer";

export const calculateAvailableQuantity = (product: ProductListItem) => {
  const { onHandQty = 0, unfilledOrderQty = 0, unavailableQty = 0 } = product.raw || product || {};

  const result = onHandQty - unfilledOrderQty - unavailableQty;
  return result < 0 ? 0 : result;
};
